
export default {
  name: 'GcAlert',
  data() {
    return {
      className: 'gc__alert',
    };
  },
  computed: {
    btClassName() {
      return `${this.className}__close-btn`;
    },
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'default',
    },
    closeable: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => null,
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
};
